import { useState } from "react"
import { useRevalidator } from "react-router"

import { useAuthorization } from "@/contexts"
import { isConnectivityError } from "@/utils/api"

export const useRetryConnectivityRecovery = () => {
  const revalidator = useRevalidator()
  const { authorizedOrganizationsError, refetchAuthorizedOrganizations } =
    useAuthorization()
  const [isOrgRefetching, setIsOrgRefetching] = useState(false)

  const isRetrying = isOrgRefetching || revalidator.state !== "idle"

  const retry = () => {
    if (isRetrying) {
      return
    }

    if (!isConnectivityError(authorizedOrganizationsError)) {
      void revalidator.revalidate()
      return
    }

    setIsOrgRefetching(true)
    void refetchAuthorizedOrganizations()
      .then(() => {
        void revalidator.revalidate()
      })
      .finally(() => {
        setIsOrgRefetching(false)
      })
  }

  return { isRetrying, retry }
}
